import { i18n } from "../i18next";
import { createCustomErrorMap } from "./create-custom-error-map";

export const errorMap = createCustomErrorMap(i18n);
